export enum TradeOfferTabsEnum {
  POSITIONS = 'positions',
  LOGISTICS = 'logistics',
  ACCOUNTING = 'accounting',
  PREFERENCES = 'preferences',
}
